<template> 
  <div>
    <b-button      
      v-if="$store.getters.userRole =='installer' || $store.getters.userRole =='collab'" 
      @click="openDetailsMonitoringZone" 
      :disabled="!this.abilita">
      <i class="fa fa-arrows-alt" ></i>
    </b-button>
    <!-- :title="$t('monitoring_zone.modal_title_details') + ': ' + $t('monitoring_zone.zone') + this.zone.zoneNumber + ' - ' + this.zone.zoneName" -->
    <!-- Crea nuova Monitoring Zone Modal-->
    <b-modal
      ref="modal"
      size="xl"
      :id="'modal-details-zone'+this.uid"     
      :hide-footer=true
      @hide="flushModal"
    >
    <!-- style="height:500px" -->
      <template #modal-header="{ close }">
        <div class="d-flex justify-content-between align-items-center">
          <span style="color:black" class="mr-1"><h5>{{$t('monitoring_zone.modal_title_details') + ':'}}</h5></span>
          <span style="color:#009DE0" class="ml-1 mr-1"><h5>{{$t('monitoring_zone.zone')}} {{ zone.zoneNumber }}</h5></span>
          <span style="color:black" class="ml-1"><h5>{{zone.zoneName }}</h5></span>
        </div>
          <b-button @click="close" aria-label="Close">
            <i class="fa fa-times"></i>
          </b-button>
        
      </template>

      <!-- modal content -->
      <b-row>

        <b-col cols="4">
        <!-- CARD WITH DONUT CHART -->
         <div class="container-fluid"> 
          <!-- <div class="flex-container" style="height:500px"> -->
          <!-- </div> style="height:500px"> -->
            <Tabs card class="p-2">
              <TabItem :name="$t('energy.energy_saving')" class="pt-5">
                <b-row class="justify-content-center">
                  <b-col cols="8" class="d-flex justify-content-left">
                    <grafico-donut-energy v-if="energyZoneGraph(this.zone) != null && this.filteredLamps!=null" :graphData="energyZoneGraph(this.zone)"/>  
                  </b-col>
                  <b-col cols="9">
                    <div class="d-flex justify-content-left mt-4">
                      <i class="fa fa-minus mt-1 mr-2" style="color:orange"></i>
                      <p class="typo-title">{{$t('energy.energy_consumed')}}: <strong>{{(Math.round(this.zone.energy_consumed)).toLocaleString('it')}} kWh</strong></p>
                    </div>
                    <div class="d-flex justify-content-left mt-1">
                      <i class="fa fa-minus mt-1 mr-2" style="color:#29CC96"></i>
                      <p class="typo-title">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(this.zone.energy_saved)).toLocaleString('it')}} kWh</strong></p>
                    </div>
                    <div class="d-flex justify-content-left mt-1">
                      <i class="fa fa-clock mt-1 mr-2" style="color:grey"></i>
                      <p class="typo-title">{{$t('energy.hours_operation')}}: <strong>{{(Math.round(this.zone.working_time)).toLocaleString('it')}} h</strong></p>
                    </div>
                  </b-col>
                </b-row>
              </TabItem>
              <TabItem :name="$t('energy.environmental_benefits')"  class="pt-4">
                <b-row class="d-flex mt-5 ml-5">
                    <b-col cols="2" >
                        <i class="fa fa-plug fa-2x mt-1" style="color:#009DE0;"></i>
                    </b-col>
                    <b-col cols="10">
                        <p class="typo-title mt-2">{{$t('energy.energy_saved')}}: <strong>{{(Math.round(this.zone.energy_saved)).toLocaleString('it')}} kWh</strong></p>
                    </b-col>
                </b-row>
                <b-row class="d-flex mt-4 ml-5">
                    <b-col cols="2" >
                        <i class="fa fa-cloud fa-2x mt-1" style="color:gray;"></i>
                    </b-col>
                    <b-col cols="10">
                        <p class="typo-title mt-2">{{$t('energy.CO2')}}: <strong>{{(Math.round(this.zone.energy_saved*0.5)).toLocaleString('it')}} Kg</strong></p>
                    </b-col>    
                </b-row>    
                <b-row class="d-flex mt-4 ml-5">
                    <b-col cols="2">
                        <i class="fa fa-tint fa-2x mt-1 pl-2" style="color:black;"></i>
                    </b-col>
                    <b-col cols="10">
                        <p class="typo-title mt-2">{{$t('energy.oil')}}: <strong>{{(this.zone.energy_saved*0.000187).toFixed(2).toLocaleString('it')}}</strong></p>                                       
                    </b-col>    
                </b-row>
                <b-row class="d-flex mt-4 ml-5">
                    <b-col cols="2">
                        <i class="fa fa-tree fa-2x mt-1 pl-2" style="color:green;"></i>
                    </b-col>
                    <b-col cols="10">
                        <p class="typo-title mt-2">{{$t('energy.trees')}}: <strong>{{(Math.round(this.zone.energy_saved/20)).toLocaleString('it')}}</strong></p>                                       
                    </b-col>    
                </b-row>
              </TabItem>
            </Tabs>
          </div>
        </b-col>

        <b-col cols="8">
          
         <b-row style="display: flex; align-items: center">
            <b-col cols="6">
                <div class="mt-4 pb-4 typo-title"><b>{{(this.zone.energy_lamps.length + " " + $t('monitoring_zone.lamps_in_zone')).toLowerCase()}}</b></div>
            </b-col>
  
            <b-col cols="5">
              <b-input-group>
              <b-form-input type="text" v-model="filtro_in_tab"></b-form-input>
            
              <!-- Attach Right button -->
                <b-input-group-append>
                  <b-button variant="primary" @click="filtro=filtro_in_tab"><i class="fa fa-search"></i></b-button>
                </b-input-group-append>       
                <span class="ml-1" :content="$t('monitoring_zone.search')" v-tippy="{ placement : 'top',  arrow: true}"> <i class="fa fa-1x fa-info-circle" style="color:#009de0"></i></span> 
              </b-input-group>
            </b-col>    
            
         </b-row>


          <table v-if="this.filteredLamps!=null" lazy class="table tabLampadeEnergy" >
              <thead>
                  <tr>
                      <th style="width:5%"></th>
                      <th style="width:10%"></th>
                      <th style="width:10%">ID</th>
                      <th style="width:25%">{{ $t('details_lamp.lamp_desc')}}</th>
                      <th style="width:10%">System</th>
                      <th style="width:10%">Central</th>
                      <th style="width:20%">{{ $t('energy.energy_saving')}}</th>
                      <th style="width:10%"></th>
                  </tr>
              </thead>
              <tbody> 
                  <b-form-checkbox-group id="checkbox-lamp-to-remove" v-model="lampSelectedToRemove">
                    <tr v-for="(lamp,index) in this.filteredLamps" :key="index">
                      <td style="width:5%">
                      <b-checkbox :value='lamp.id + "#" + lamp.cu_id' />
                      </td>      
                      <td style="width:10%">
                          <img v-if="lamp.product_image.includes('.jpg') || lamp.product_image.includes('.png')" :src="pathDeviceImages + lamp.product_image" style="width:60px;" />
                      </td>
                      
                      <td style="width:10%"><strong>{{lamp.id}}</strong></td>
                      <td style="width:25%">{{lamp.desc}}</td>
                      <td style="width:10%">{{lamp.cu_type}}</td>
                      <td style="width:10%">{{lamp.cu_id.split("#")[1]}}</td>
                      <td style="width:20%"><b>{{((lamp.energia_risparmiata/(lamp.energia_consumata/1+lamp.energia_risparmiata/1)*100).toFixed(1) == "NaN" ? "0.0" : (lamp.energia_risparmiata/(lamp.energia_consumata/1+lamp.energia_risparmiata/1)*100).toFixed(1)) + "%"}}</b></td>
                      <td style="width:10%"><icon-error-lamp :lamp="lamp" v-if='lamp!=null'></icon-error-lamp></td>
                    </tr>
                  </b-form-checkbox-group>  
              </tbody>
          </table>
          <div style="text-align:end;">
            <b-button v-if="lampSelectedToRemove.length>0" variant="primary" @click="showModalRemoveLamps()"> 
              <span>{{$t('monitoring_zone.lamps_remove')}}</span>
            </b-button>
          </div>

        </b-col>
      
      </b-row>

    </b-modal>

   <!-- Modal Rimuovi lampada da mappa-->
    <b-modal 
      id="modal-remove-lamps" 
      ref="modal-remove-lamps"
       centered 
       hide-header
       @ok="confirmRemoveLamps()"
    >
    <h5 v-if="this.lampSelectedToRemove.length>0">{{$t('monitoring_zone.lamps_remove_confirm')}}</h5>
    <ol>
      <li v-for="(lamp,index) in this.lampSelectedToRemove" :key="index"><h5>{{lamp.split('#')[0]}}</h5></li>
    </ol>
    </b-modal>

  </div>
</template>

<script>
import IconErrorLamp from '@/components/IconErrorLamp.vue'
import GraficoDonutEnergy from '@/components/GraficoDonutEnergy';
import { mapState } from "vuex";

export default {
  name: "DetailsMonitoringZone",
  components: {
    GraficoDonutEnergy,
    IconErrorLamp
  },
  data() {
    return {
     pathDeviceImages: process.env.VUE_APP_PATH_DEVICE_IMAGES,     
     zoneName: "",
     lampSelectedToRemove: [],
     filtro_in_tab: "",
     filtro:"",
     uid: Math.random(),
    };
  },
  props: {
    zone: {
      default: null
    },
    abilita: {
      default: true
    }
  },
  //---------- COMPUTED  ---------------
  computed: {
    ...mapState(['loading', 'error', 'commandsPending', 'commandResponse']),

    //restituisce le lampade filtrate in base al filtro, che appartengono alla zona di monitoraggio
    filteredLamps() {
      var lamps = [];
      var flt = this.filtro;

      if (this.zone.energy_lamps != null)
        this.zone.energy_lamps.forEach(function (lamp) {
          if (lamp.id.includes(flt) || lamp.desc.includes(flt) || lamp.cu_id.includes(flt)) {
            lamps.push(lamp);
          }
        });

      return lamps;
    }

  },
  //---------- METHODS  ---------------
  methods: {
    flushModal() {
      this.lampSelectedToRemove = [];
      console.log("flushModal");
      this.$bvModal.hide('modal-details-zone'+this.uid);
    },
    showModalRemoveLamps() {
      this.$refs['modal-remove-lamps'].show();
   },
    openDetailsMonitoringZone() {
      console.log("open details monitoring zone: ", this.filteredLamps);
      // this.$forceUpdate();
      this.$bvModal.show('modal-details-zone'+this.uid);
    }, 
    confirmRemoveLamps()
    {

      console.log("lamps to remove", this.lampSelectedToRemove);

      let newZone = {};
      newZone.zoneId = this.zone.zoneId;
      newZone.plantId = this.zone.plantId;
      newZone.working_time = this.zone.working_time;
      newZone.zoneName = this.zone.zoneName;
      newZone.zoneNumber = this.zone.zoneNumber;
      newZone.lamps = [];

      //remove lamps from new Zone
      this.zone.lamps.forEach((lamp) => {
        if (this.lampSelectedToRemove.includes(lamp.id + "#" + lamp.cu_id))
        {
          console.log("lamp to remove", lamp);
        }
        else
        {
          console.log("lamp manteined", lamp);
          newZone.lamps.push(lamp);
        }
      });
      
      console.log("new monitoring zone to update in db", newZone);
      this.updateZone(newZone);

    },
    updateZone(zoneUpdated) {     
      console.log("confirm remove lamps", zoneUpdated);
      this.$store.dispatch("updateMonitoringZone", zoneUpdated);

      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs.modal.hide();
      });
      
    },
    energyZoneGraph(zone){
      console.log("energyZoneGraph, zone: ", zone, zone.lamps.length);
      if (zone.lamps.length > 0) {
        return ["energy",zone.energy_saved.toFixed(0),zone.energy_consumed.toFixed(0)];
      }
      else {
        return null;
      }
    },
  },

  watch: {
    loading(val) {
        console.log("zone loading changed:" + val+", error=" + this.error)
    },
    commandResponse(val) {
      console.log("updated commandResponse:",val);
      if (val.command == 'deleteMonitoringZone' && val.pending == false && val.error.data == '') 
        {
          console.log("monitoring zone deleted", val);
          this.$store.dispatch('loadPlantMonitoringZones', this.zone.plantId);  
        } 
    },
    abilita(val) {
      console.log("abilita changed:",val);
    }

  },
  mounted() {
    console.log("mounted, details monitoring zone: ", this.filteredLamps);
    if (this.abilita) console.log("Pulsante ABILITATO");
    else console.log("Pulsante DISABILITATO");
    return null;
  }
  
};
</script>
